export default "__VITE_ASSET__pguYA9GZ__"